import {
  targetsService,
  adminService,
  targetSequencesService,
} from "@/_services";
import { router } from "@/_helpers";
import moment from "moment";
import i18n from "@/_helpers/i18n";
import { parseContactSearchError } from "@/_helpers/salesridgeSearchError";
import { authentication } from "./authentication.module";

const getTranslates = (items, field) => {
  return items.map(function (element) {
    if (element.translated === undefined) {
      element[field] = i18n.t("lang.optionlist." + element[field]);
      element.translated = true;
    }
    return element;
  });
};

const normalizeKeywordFilter = (value) => {
  const source =
    value && typeof value === "object" && !Array.isArray(value) ? value : {};
  return {
    ...source,
    anyof: Array.isArray(source.anyof) ? source.anyof : [],
    notanyof: Array.isArray(source.notanyof) ? source.notanyof : [],
  };
};

export const onboarding = {
  namespaced: true,
  companyName: "",
  state: {
    tabs: {
      1: {
        id: 1,
        name: i18n.t("lang.label.personalizedsequence"),
        disabled: false,
      },
      2: {
        id: 2,
        name: i18n.t("lang.label.template"),
        disabled: false,
      },
      3: {
        id: 3,
        name: i18n.t("lang.label.openai_sequences"),
        disabled: false,
      },
    },
    updateStatusToPreapring: false,
    modelCampaingStep: {
      campaign: {
        is_agency: 1,
      },
      campaign_steps: [],
      tabSelected: {
        id: 0,
        disabled: false,
      },
    },
    validationTarget: {
      status: 0,
      comment: "",
      label: "",
    },
    emailDataToken: [
      {
        "[prospect_last_name]": "",
        "[prospect_first_name]": "",
        "[prospect_city]": "",
        "[prospect_website_url]": "",
        "[prospect_company_name]": "",
        "[gender]": "M",
        "[prospect_job_title]": "Marketing",
        "[product_market_area]": "France",
        "[product_year_start]": "2011",
        "[product_name]": "",
        "[we_propose]": "",
        "[we_are_convinced]": "",
        "[in_few_words]": "",
        "[we_wanted_to_exchange_about]": "",
        "[the_idea_is_simple]": "",
        "[we_were_wondering_how]": "",
        "[what_we_created]": "",
        "[prospect_area]": "",
        "[argument_1]": "",
        "[argument_2]": "",
        "[argument_3]": "",
        "[ref_1]": "",
        "[ref_2]": "",
        "[ref_3]": "",
        "[custom_sentence]": "",
      },
    ],
    companyName: "",
    descriptions: [
      {
        substep: 3,
        arg: "what_we_created",
        order: 1,
      },
      {
        substep: 4,
        arg: "we_propose",
        order: 1,
      },
      {
        substep: 5,
        arg: "we_are_convinced",
        order: 1,
      },
      {
        substep: 6,
        arg: "in_few_words",
        order: 1,
      },
      {
        substep: 7,
        arg: "we_wanted_to_exchange_about",
        order: 1,
      },
      {
        substep: 8,
        arg: "the_idea_is_simple",
        order: 1,
      },
      {
        substep: 9,
        arg: "we_were_wondering_how",
        order: 1,
      },
      {
        substep: 10,
        arg: "prospect_area",
        order: 1,
      },
      {
        substep: 11,
        arg: "argument_1",
        order: 1,
      },
      {
        substep: 11,
        arg: "argument_2",
        order: 2,
      },
      {
        substep: 11,
        arg: "argument_3",
        order: 3,
      },
      {
        substep: 12,
        arg: "ref_1",
        order: 1,
      },
      {
        substep: 12,
        arg: "ref_2",
        order: 2,
      },
      {
        substep: 12,
        arg: "ref_3",
        order: 3,
      },
    ],
    warmup_active: 1,
    create_mailboxes: 1,
    order_type: "acquisition",
    activationContactsCount: 0,
    activationContactsWithEmailCount: 0,
    linkedContactsCount: 0,
    conditionPayment: "ok",
    loadingTemplate: true,
    step1Ready: false,
    step2Ready: false,
    readyToPrepear: false,
    loading: false,
    targetWasLoaded: false,
    isDisable: false,
    disablednext: false,
    disabledskip: true,
    limitA: 1000,
    limitB: 50000,
    limitC: 20000,
    showback: true,
    shownext: true,
    orderId: 0,
    isCopyTarget: null,
    lang: "en",
    startProcess: true,
    step: 1,
    bookers: [],
    substep: 0,
    orderName: "",
    size: {
      greater: 0,
      less: 0,
    },
    steps: [
      {
        min: 0,
        max: 6,
      },
      {
        min: 1,
        max: 2,
      },
      {
        min: 1,
        max: 1,
      },
    ],
    statusOnboarding: [
      { name: "firstOrder", value: true },
      { name: "blacklist", value: false },
      { name: "avatar", value: false },
      { name: "emailSincronized", value: false },
    ],
    typeForm: "",
    productName: "",
    link: "",
    language_id: 0,
    client_creation_date: "",
    landing_page: "",
    descriptionSell: "",
    descriptionOrder: "",
    coldcallspec: "",
    manual_cold_call_script: "",
    offer_prospect: 0,
    offer_benefits: "",
    offer_attractive: "",
    client_id: 0,
    adminPrice: 0,
    appt_price: 0,
    previewTemplate: 1,
    website: "",
    target_status_id: null,
    isMonthlyPaused: false,
    hoursPaused: 0,
    user_id: null,
    toSettingAccount: false,
    total_meetings_this_month: 0,
    questions: {
      data: [
        {
          question: 5,
          description:
            "Complete this step by putting yourself in the shoes of your prospects. What are the problems they encounter in the field on a daily basis? Give concrete examples",
          answers: [
            { number: 1, text: "" },
            { number: 2, text: "" },
            { number: 3, text: "" },
          ],
        },
        {
          question: 6,
          description:
            "Here we ask you to put forward elements of 'social proof'. Successful projects, certifications or any other element that gives credibility to your offer",
          answers: [
            { number: 1, text: "" },
            { number: 2, text: "" },
            { number: 3, text: "" },
          ],
        },
      ],
    },
    apollo: {
      people: [],
      total_result: 0,
      search_error: null,
      applied_filters: [],
      salesridge_payload: null,
      salesridge_launch_ui: null,
    },
    orderdata: {},
    select_list_sizes: [
      { id: 0, label: "1-10" },
      { id: 1, label: "11-20" },
      { id: 2, label: "21-50" },
      { id: 3, label: "51-100" },
      { id: 4, label: "101-200" },
      { id: 5, label: "201-500" },
      { id: 6, label: "501-1000" },
      { id: 7, label: "1001-2000" },
      { id: 8, label: "2001-5000" },
      { id: 9, label: "5001-10000" },
      { id: 10, label: "10001+" },
    ],
    step1: {
      questions: {},
      we_propose: "",
      we_are_convinced: "",
      in_few_words: "",
      we_wanted_to_exchange_about: "",
      serviceDescription_5: "",
      the_idea_is_simple: "",
      serviceDescription_7: "",
      we_were_wondering_how: "",
      what_we_created: "",
      prospect_area: "",
      argument_1: "",
      argument_2: "",
      argument_3: "",
      ref_1: "",
      ref_2: "",
      ref_3: "",
    },
    target: {
      category_select: 0,
      positions: [],
      departments: [],
      sizes: [],
      places: [],
      categories_select: [],
      summary: "",
      categories_jobs: {},
      industry_keywords: {},
      specialties: {},
      location_keywords: {},
      sectors_include: [],
      sectors_exclude: [],
      contact_country: [],
      company_location: [],
      employees: {
        greater: 0,
        less: 0,
      },
    },
    step3: {
      appointmentVolume: 20,
      newEmailsPerDay: 35,
      totalEmailsPerDay: 120,
      tag_id: "",
      launchDate: "",
      teamMembers: [],
      updateSales: [],
      appointmentPrice: "0",
      pausedDie: "",
      tabId: 1,
      duplicate_reason: "",
    },
    summary: {
      progressBarColor: "bg-danger",
      progressBarPercentage: "width: 25%",
    },
    audience_description: "",
    audience: "",
  },
  mutations: {
    setStartProcess(state) {
      state.startProcess = !state.startProcess;
    },
    setDuplicateReason(state, reason) {
      state.step3.duplicate_reason = reason;
    },
    validateStep(state) {
      if (state.typeForm !== "add") {
        if (state.orderId != 0) {
          state.startProcess = true;
          state.loading = false;
        }
      }
    },
    setOrderData(state) {
      state.orderdata = {
        target_id: state.orderId,
        language_id: state.language_id,
        name: state.step3.name,
        appt_quantity: state.step3.appointmentVolume,
        new_emails_per_day: state.step3.newEmailsPerDay,
        total_emails_per_day: state.step3.totalEmailsPerDay,
        tag_id: state.step3.tag_id,
        warmup_active: state.warmup_active,
        create_mailboxes: state.create_mailboxes,
        salesRep: state.step3.teamMembers,
        preview_template: state.previewTemplate,
        data: {
          categories_level: state.target.positions,
          categories_function: state.target.departments,
          categories_industry: state.target.sectors_include,
          categories_not_industry: state.target.sectors_exclude,
          region: state.target.company_location,
          countries: state.target.contact_country,
          categories_jobs: state.target.categories_jobs,
          industry_keywords: state.target.industry_keywords,
          specialties: state.target.specialties,
          location_keywords: state.target.location_keywords,
          employees: state.size,
          category_select: state.target.category_select,
          places: state.target.places,
          summary: state.target.summary,
          categories_select: state.target.categories_select,
        },
        questions: state.questions,
        launch_date_campaign: state.step3.launchDate,
        name: state.orderName,
        description_sell: state.descriptionSell,
        description_order: state.descriptionOrder,
        coldcallspec: state.coldcallspec,
        manual_cold_call_script: state.manual_cold_call_script,
        product_name: state.productName,
        we_propose: state.step1.we_propose,
        we_are_convinced: state.step1.we_are_convinced,
        in_few_words: state.step1.in_few_words,
        we_wanted_to_exchange_about: state.step1.we_wanted_to_exchange_about,
        the_idea_is_simple: state.step1.the_idea_is_simple,
        we_were_wondering_how: state.step1.we_were_wondering_how,
        what_we_created: state.step1.what_we_created,
        prospect_area: state.step1.prospect_area,
        argument_1: state.step1.argument_1,
        argument_2: state.step1.argument_2,
        argument_3: state.step1.argument_3,
        ref_1: state.step1.ref_1,
        ref_2: state.step1.ref_2,
        ref_3: state.step1.ref_3,
        landing_page: state.website,
        user_id: state.user_id,
        closed: state.closed,
        offer_prospect: state.offer_prospect,
        offer_benefits: state.offer_benefits,
        offer_attractive: state.offer_attractive,
        client_id: state.client_id,
        sequence_type: state.sequence_type,
        audience: state.audience,
        audience_description: state.audience_description,
        order_type: state.order_type,
      };

      let categories_jobs = {
        anyof:
          state.target.categories_jobs.anyof !== undefined
            ? state.target.categories_jobs.anyof
            : [],
        notanyof:
          state.target.categories_jobs.notanyof !== undefined
            ? state.target.categories_jobs.notanyof
            : [],
        known:
          state.target.categories_jobs.known !== undefined
            ? state.target.categories_jobs.known
            : undefined,
        unknown:
          state.target.categories_jobs.unknown !== undefined
            ? state.target.categories_jobs.unknown
            : undefined,
        exactmatch:
          state.target.categories_jobs.exactmatch !== undefined
            ? state.target.categories_jobs.exactmatch
            : undefined,
      };

      if (state.order_type === "activation" && state.activationContactsCount > 0) {
        state.orderdata.total_contacts = state.activationContactsCount;
      } else if (state.apollo.total_result > 0) {
        state.orderdata.total_contacts = state.apollo.total_result;
      }

      state.orderdata.data.categories_jobs = categories_jobs;

      ["industry_keywords", "specialties", "location_keywords"].forEach(
        (key) => {
          const { anyof, notanyof } = normalizeKeywordFilter(state.target[key]);
          state.orderdata.data[key] = { anyof, notanyof };
        }
      );

      switch (state.language_id) {
        case 1:
          state.lang = "fr";
          break;
        case 2:
          state.lang = "en";
          break;
        case 3:
          state.lang = "es";
          break;
        case 4:
          state.lang = "it";
          break;
        case 5:
          state.lang = "pt";
          break;
        default:
          state.lang = "fr";
          break;
      }

      if (state.orderId === 0) state.target_status_id = 3;
    },
    clean(state) {
      state.lang = "";
      state.orderName = "";
      state.productName = "";
      state.descriptionSell = "";
      state.descriptionOrder = "";
      state.website = "";
      state.target_status_id = null;
      state.user_id = null;
      state.apollo.people = [];
      state.apollo.total_result = 0;
      state.apollo.search_error = null;
      state.apollo.applied_filters = [];
      state.apollo.salesridge_payload = null;
      state.apollo.salesridge_launch_ui = null;
      state.step1.we_propose = "";
      state.step1.we_are_convinced = "";
      state.step1.in_few_words = "";
      state.step1.we_wanted_to_exchange_about = "";
      state.step1.the_idea_is_simple = "";
      state.step1.we_were_wondering_how = "";
      state.step1.what_we_created = "";
      state.step1.prospect_area = "";
      state.step1.argument_1 = "";
      state.step1.argument_2 = "";
      state.step1.argument_3 = "";
      state.step1.ref_1 = "";
      state.step1.ref_2 = "";
      state.step1.ref_3 = "";
      state.language_id = 0;
      state.step = 1;
      state.substep = 0;
      state.orderId = 0;
      state.targetWasLoaded = false;
      state.loading = false;
      state.target.positions = [];
      state.target.departments = [];
      state.target.sizes = [];
      state.target.sectors_exclude = [];
      state.target.sectors_include = [];
      state.target.contact_country = [];
      state.target.company_location = [];
      state.target.categories_jobs = {};
      state.target.industry_keywords = {};
      state.target.specialties = {};
      state.target.location_keywords = {};
      state.step3.appointmentVolume = 20;
      state.step3.newEmailsPerDay = 35;
      state.step3.totalEmailsPerDay = 120;
      state.step3.tag_id = null;
      state.step3.appointmentPrice = 0;
      state.step3.teamMembers = [];
      state.summary.progressBarColor = "bg-danger";
      state.summary.progressBarPercentage = "width:25%";
      state.order_type = "acquisition";
      state.activationContactsCount = 0;
      state.activationContactsWithEmailCount = 0;
      state.linkedContactsCount = 0;
    },
    apolloData(state, apollo) {
      state.apollo = apollo;
      onboarding.mutations.calculatePrice(state);
    },
    updateConditionPayment(state, condition) {
      state.conditionPayment = condition;
    },
    updateAdminPrice(state, adminPrice) {
      state.adminPrice = adminPrice;
      onboarding.mutations.validateForm(state);
    },
    updatePreviewTemplate(state, previewTemplate) {
      state.previewTemplate = previewTemplate;
      onboarding.mutations.validateForm(state);
    },
    setTypeForm(state, type) {
      state.typeForm = type;
    },
    changeLang(state, lang) {
      state.lang = lang;
    },
    back(state) {
      if (state.steps[state.step - 1].min >= state.substep) {
        //si ya llegue al minimo
        if (state.step >= 1) {
          state.step = state.step - 1;
          state.substep = state.steps[state.step].min;
          state.shownext = true;
          return;
        } else {
          //volver al inicio de todo

          state.showback = false;
          state.shownext = true;
        }
      } else {
        // if(state.step === 1 && authentication.state.user.role_id === '1') {
        //   state.substep = state.substep - 1
        //   state.startProcess = false
        //   return
        // }
        state.substep = state.substep - 1;
        // if(state.step === 1 && authentication.state.user.role_id === '1') {
        //   state.startProcess = false
        // } else {
        state.startProcess = true;
        //}
      }
      if (
        state.typeForm !== "add" &&
        router.currentRoute.fullPath !==
          "/onboarding/" + state.step + "/" + state.substep
      ) {
        router.push("/onboarding/" + state.step + "/" + state.substep);
      }
    },
    next(state, startProcess = null) {
      // si estoy en la primer pantalla.
      if (startProcess) {
        if (state.step == 2 && state.substep == 2) {
          state.step = 3;
          state.substep = 1;
        }
        state.startProcess = false;
      } else {
        if (state.steps[state.step - 1].max < state.substep + 1) {
          //si ya llegue al minimo
          if (state.step < 3) {
            state.step = state.step + 1;
            state.substep = state.steps[state.step - 1].min;
            state.shownext = true;
            //console.log('minimo....Step', state.step, 'Substep', state.substep);
          } else {
            state.shownext = false;
          }
        } else {
          state.substep = state.substep + 1;
        }
        if (
          state.typeForm !== "add" &&
          router.currentRoute.fullPath !==
            "/onboarding/" + state.step + "/" + state.substep
        ) {
          let name = "";
          if (state.step === 1) {
            name = "Vos services" + "-" + state.step + "." + state.substep;
          } else if (state.step === 2) {
            name = "Votre cible" + "-" + state.step + "." + state.substep;
          } else {
            name = " Résumé";
          }
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "Funnel_Paiement",
            stepName: name,
            stepNumber: state.step + "." + state.substep,
          });
          router.push("/onboarding/" + state.step + "/" + state.substep);
        }
      }
    },
    validateForm(state) {
      state.readyToPrepear = true;
      if (state.typeForm !== "add") {
        const isActivation = state.order_type === "activation";
        const apolloTooLow = !isActivation && state.apollo.total_result < 3000;
        const activationHasNoContacts =
          isActivation && state.activationContactsCount < 1;
        const activationHasNoEmailContact =
          isActivation &&
          state.activationContactsCount > 0 &&
          state.activationContactsWithEmailCount < 1;

        if (
          state.language_id == 0 ||
          state.productName == "" ||
          state.website == "" ||
          state.offer_prospect == 0 ||
          state.descriptionSell == "" ||
          state.descriptionOrder == "" ||
          apolloTooLow ||
          activationHasNoContacts ||
          activationHasNoEmailContact ||
          (state.questions.data[0].question == 5 &&
            (state.questions.data[0].answers[0].text == "" ||
              state.questions.data[0].answers[1].text == "" ||
              state.questions.data[0].answers[2].text == "")) ||
          (state.questions.data[1].question == 6 &&
            (state.questions.data[1].answers[0].text == "" ||
              state.questions.data[1].answers[1].text == "" ||
              state.questions.data[1].answers[2].text == ""))
        ) {
          state.readyToPrepear = false;
        }
      }
      return state.readyToPrepear;
    },
    disableSkip(state) {
      if (state.step == 1) {
        switch (state.substep) {
          case 1:
            state.disabledskip = !state.productName;
            break;
          case 2:
            state.disabledskip = !state.website;
            //state.disabledskip = false
            break;
          case 3:
            state.disabledskip = !state.step1.what_we_created;
            break;
          case 4:
            state.disabledskip = !state.step1.we_propose;
            break;
          case 5:
            state.disabledskip = !state.step1.we_are_convinced;
            break;
          case 6:
            state.disabledskip = !state.step1.in_few_words;
            break;
          case 7:
            state.disabledskip = !state.step1.we_wanted_to_exchange_about;
            break;
          case 8:
            state.disabledskip = !state.step1.the_idea_is_simple;
            break;
          case 9:
            state.disabledskip = !state.step1.we_were_wondering_how;
            break;
          case 10:
            state.disabledskip = !state.step1.prospect_area;
            break;
          case 11:
            state.disabledskip =
              !state.step1.argument_1 ||
              !state.step1.argument_2 ||
              !state.step1.argument_3;
            break;
          case 12:
            state.disabledskip =
              !state.step1.ref_1 || !state.step1.ref_2 || !state.step1.ref_3;
            break;
        }
      }
    },
    urlValid(state) {
      if (state.website) {
        var re =
          /^(?!.*\s).*\.[a-zA-Z0-9#\-]{2,15}(?:\/[a-zA-Z0-9\-]+)*(?:#.*)?$/;
        if (re.test(state.website)) {
          return true;
        } else {
          return false;
        }
      }
    },
    disableButton(state) {
      if (state.step == 1) {
        switch (state.substep) {
          case 1:
            state.disablednext = !state.productName; // || !state.step3.tag_id
            break;
          case 2:
            if (onboarding.mutations.urlValid(state)) {
              state.disablednext = !state.website;
              state.disablednext = false;
            } else {
              state.disablednext = true;
            }
            break;
          case 3:
            state.disablednext = !state.offer_prospect;
            break;
          case 4:
            state.disablednext = !state.descriptionSell;
            break;
          case 5:
            const question5 = state.questions.data.find(
              (el) => el.question === 5
            );
            state.disablednext = true;
            if (question5) {
              const answersWithContent = question5.answers.filter(
                (answer) => answer.text !== ""
              );
              if (answersWithContent.length === 3) {
                state.disablednext = false;
              }
            }
            break;
          case 6:
            const question6 = state.questions.data.find(
              (el) => el.question === 6
            );
            state.disablednext = true;
            if (question6) {
              const answersWithContent = question6.answers.filter(
                (answer) => answer.text !== ""
              );
              if (answersWithContent.length === 3) {
                state.disablednext = false;
              }
            }
            break;
            break;
          case 7:
            state.disablednext = !state.step1.we_wanted_to_exchange_about;
            break;
          case 8:
            state.disablednext = !state.step1.the_idea_is_simple;
            break;
          case 9:
            state.disablednext = !state.step1.we_were_wondering_how;
            break;
          case 10:
            state.disablednext = !state.step1.prospect_area;
            break;
          case 11:
            state.disablednext =
              !state.step1.argument_1 ||
              !state.step1.argument_2 ||
              !state.step1.argument_3;
            break;
          case 12:
            state.disablednext =
              !state.step1.ref_1 || !state.step1.ref_2 || !state.step1.ref_3;
            break;
        }
      }

      if (state.step == 3) {
        if (onboarding.mutations.urlValid(state)) {
          state.disablednext = false;
        } else {
          state.disablednext = true;
        }
      }
    },
    goTo(state, steps) {
      if (!steps.step) {
        state.step = parseInt(1);
      } else {
        state.step = parseInt(steps.step);
      }
      if (!steps.substep) {
        if (state.step == 3) {
          state.substep = parseInt(1);
        } else {
          state.substep = parseInt(0);
        }
      } else {
        state.substep = parseInt(steps.substep);
      }
      if (state.step == 2) {
        state.disablednext = false;
      }
    },

    goToStep(state, step) {
      if (step == null || step == undefined) {
        step = 3;
      }
      state.step = step;
      if (state.step == 2) {
        state.disablednext = false;
      }
      if (
        state.typeForm !== "add" &&
        router.currentRoute.fullPath !==
          "/onboarding/" + state.step + "/" + state.substep
      ) {
        let name = "";
        if (state.step === 1) {
          name = "Vos services" + "-" + state.step + "." + state.substep;
        }
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "Funnel_Paiement",
          stepName: name,
          stepNumber: state.step + "." + state.substep,
        });
        router.push("/onboarding/" + state.step + "/" + state.substep);
      }
    },
    goToSubStep(state, substep) {
      if (substep == null || substep == undefined) {
        step = 1;
      }
      if (state.step == 3 && substep == 0) {
        state.substep = parseInt(1);
      } else {
        state.substep = substep;
      }
    },
    updatePrice(state, price) {
      state.step3.appointmentPrice = price;
      onboarding.mutations.validateForm(state);
    },
    updateNewEmailsPerDay(state, newEmailsPerDay) {
      state.step3.newEmailsPerDay = newEmailsPerDay;
      onboarding.mutations.validateForm(state);
    },
    updateTotalEmailsPerDay(state, totalEmailsPerDay) {
      state.step3.totalEmailsPerDay = totalEmailsPerDay;
      onboarding.mutations.validateForm(state);
    },
    setOrderId(state, id) {
      state.orderId = id;
    },
    setTabStep3(state, id) {
      state.step3.tabId = id;
    },
    setTab(state, id) {
      // console.log('stete.step...........', state.step);
      // if(state.step == 3) {
      //   state.step3.tabId = id
      // } else {
      state.modelCampaingStep.tabSelected.id = id;
      state.sequence_type = id;
      //}
    },
    setIsCopyTarget(state, value) {
      state.isCopyTarget = value;
    },
    setStatusOnboarding(state, item) {
      state.statusOnboarding.find((e) => e.name === item.name).value =
        item.value;
    },
    setClientId(state, id) {
      state.client_id = id;
    },
    setUserId(state, id) {
      state.user_id = id;
    },
    setLanguageId(state, id) {
      state.language_id = id;

      switch (state.language_id) {
        case 1:
          state.lang = "fr";
          break;
        case 2:
          state.lang = "en";
          break;
        case 3:
          state.lang = "es";
          break;
        case 4:
          state.lang = "it";
          break;
        case 5:
          state.lang = "pt";
          break;
        default:
          state.lang = "fr";
          break;
      }
    },
    setLoading(state, status) {
      state.loading = status;
    },
    setIsMonthlyPaused(state, status) {
      state.isMonthlyPaused = status;
    },
    setHoursPaused(state, status) {
      state.hoursPaused = status;
    },
    updateOrderName(state, orderName) {
      state.orderName = orderName;
      onboarding.mutations.validateForm(state);
    },
    updateCategorySelect(state, id) {
      state.target.category_select = id;
      onboarding.mutations.validateForm(state);
    },
    updateDescriptionSell(state, descriptionSell) {
      state.descriptionSell = descriptionSell;
      onboarding.mutations.validateForm(state);
    },
    updateDescriptionOrder(state, descriptionOrder) {
      state.descriptionOrder = descriptionOrder;
      onboarding.mutations.validateForm(state);
    },
    updateColdCallspec(state, coldcallspec) {
      state.coldcallspec = coldcallspec;
      onboarding.mutations.validateForm(state);
    },
    updateManualColdCallScript(state, manual_cold_call_script) {
      state.manual_cold_call_script = manual_cold_call_script;
      onboarding.mutations.validateForm(state);
    },
    updateQuestions(state, data) {
      state.questions.data
        .find((e) => e.question === data.question)
        .answers.find((el) => el.number === data.answer).text = data.input;
      onboarding.mutations.validateForm(state);
    },
    updateOfferAttractive(state, offer_attractive) {
      state.offer_attractive = offer_attractive;
      onboarding.mutations.validateForm(state);
    },
    updateBenefitsOffer(state, offer_benefits) {
      state.offer_benefits = offer_benefits;
      onboarding.mutations.validateForm(state);
    },
    updateWebsite(state, website) {
      state.website = website;
      onboarding.mutations.validateForm(state);
    },
    updateTargetStatusId(state, targetStatusId) {
      state.target_status_id = targetStatusId;
      onboarding.mutations.validateForm(state);
    },
    updateStatusToPreapring(state, value) {
      state.updateStatusToPreapring = value;
    },
    updateProductName(state, productName) {
      state.productName = productName;
      onboarding.mutations.validateForm(state);
    },
    // updateLink(state, link) {
    //   state.website= link
    //   onboarding.mutations.validateForm(state)
    // },
    updateTagId(state, tagId) {
      state.step3.tag_id = tagId;
      onboarding.mutations.validateForm(state);
    },
    updateOfferProspect(state, offer) {
      state.offer_prospect = offer;
      onboarding.mutations.validateForm(state);
    },
    updateCompanyName(state, company) {
      state.companyName = company;
      onboarding.mutations.validateForm(state);
    },
    updateServiceDescription(state, args) {
      state.descriptions.forEach((r) => {
        if (r.substep == state.substep && args.order == r.order) {
          state.step1[r.arg] = args.text;
          state.emailDataToken[0]["[" + r.arg + "]"] = args.text;
          return;
        }
      });
      onboarding.mutations.validateForm(state);
    },
    updateDescription(state, args) {
      state.step1[args.field] = args.value;
      state.emailDataToken[0]["[" + args.field + "]"] = args.value;
      onboarding.mutations.validateForm(state);
    },
    updateAppointmentVolume(state, appointmentVolume) {
      state.step3.appointmentVolume = appointmentVolume;
      onboarding.mutations.validateForm(state);
    },
    updateLaunchDate(state, launchDate) {
      state.step3.launchDate = launchDate;
      onboarding.mutations.validateForm(state);
    },
    updateTeamMembers(state, array) {
      state.step3.teamMembers = array;
      onboarding.mutations.validateForm(state);
    },
    updateSales(state, array) {
      state.step3.updateSales = array;
      onboarding.mutations.validateForm(state);
    },
    updatePositions(state, array) {
      state.target.positions = array;
      onboarding.mutations.validateForm(state);
    },
    updateDepartments(state, array) {
      state.target.departments = array;
      onboarding.mutations.validateForm(state);
    },
    updateSizes(state, array) {
      state.target.sizes = array;
      onboarding.mutations.validateForm(state);
    },
    updateSectorsExclude(state, array) {
      state.target.sectors_exclude = array;
      onboarding.mutations.validateForm(state);
    },
    updateSectorsInclude(state, array) {
      state.target.sectors_include = array;
      onboarding.mutations.validateForm(state);
    },
    updateCategoryJobs(state, array) {
      state.target.categories_jobs = array;
      onboarding.mutations.validateForm(state);
    },
    updateIndustryKeywords(state, array) {
      state.target.industry_keywords = array;
      onboarding.mutations.validateForm(state);
    },
    updateSpecialtiesKeywords(state, array) {
      state.target.specialties = array;
      onboarding.mutations.validateForm(state);
    },
    updateLocationKeywords(state, array) {
      state.target.location_keywords = array;
      onboarding.mutations.validateForm(state);
    },
    updateCountries(state, array) {
      state.target.contact_country = array;
      onboarding.mutations.validateForm(state);
    },
    updateRegions(state, array) {
      state.target.company_location = array;
      onboarding.mutations.validateForm(state);
    },
    updateSummary(state, data) {
      state.summary.progressBarColor = data.progressBarColor;
      state.summary.progressBarPercentage = data.progressBarPercentage;
      onboarding.mutations.validateForm(state);
    },
    setEmailDataToken(state) {
      state.emailDataToken[0] = {
        "[prospect_last_name]": "",
        "[prospect_first_name]": "",
        "[prospect_city]": "",
        "[prospect_website_url]": "",
        "[prospect_company_name]": "AIVONI",
        "[my_company_name]": state.companyName,
        "[gender]": "M",
        "[prospect_job_title]": "Marketing",
        "[product_market_area]": "France",
        "[product_year_start]": "2011",
        "[product_name]": state.productName,
        "[we_propose]": state.step1.we_propose,
        "[we_are_convinced]": state.step1.we_are_convinced,
        "[in_few_words]": state.step1.in_few_words,
        "[we_wanted_to_exchange_about]":
          state.step1.we_wanted_to_exchange_about,
        "[the_idea_is_simple]": state.step1.the_idea_is_simple,
        "[we_were_wondering_how]": state.step1.we_were_wondering_how,
        "[what_we_created]": state.step1.what_we_created,
        "[prospect_area]": state.step1.prospect_area,
        "[argument_1]": state.step1.argument_1,
        "[argument_2]": state.step1.argument_2,
        "[argument_3]": state.step1.argument_3,
        "[ref_1]": state.step1.ref_1,
        "[ref_2]": state.step1.ref_2,
        "[ref_3]": state.step1.ref_3,
        "[custom_sentence]": "",
      };
    },
    setAudience(state, data) {
      state.audience = data;
    },
    setAudienceDescription(state, data) {
      //console.log(data)
      state.audience_description = data;
    },
    setOrderType(state, orderType) {
      state.order_type =
        orderType === "activation" ? "activation" : "acquisition";
    },
    setActivationContactsCount(state, count) {
      state.activationContactsCount = Math.max(0, Number(count) || 0);
      state.linkedContactsCount = state.activationContactsCount;
      if (state.order_type === "activation") {
        state.total_contacts = state.activationContactsCount;
      }
      onboarding.mutations.validateForm(state);
    },
    setActivationContactsStats(state, stats) {
      const payload =
        stats && typeof stats === "object"
          ? stats
          : { total: stats, with_email: 0, without_email: 0 };
      state.activationContactsCount = Math.max(0, Number(payload.total) || 0);
      state.activationContactsWithEmailCount = Math.max(
        0,
        Number(payload.with_email) || 0
      );
      state.linkedContactsCount = state.activationContactsCount;
      if (state.order_type === "activation") {
        state.total_contacts = state.activationContactsCount;
      }
      onboarding.mutations.validateForm(state);
    },
    setLinkedContactsCount(state, count) {
      state.linkedContactsCount = Math.max(0, Number(count) || 0);
      if (state.order_type === "activation") {
        state.activationContactsCount = state.linkedContactsCount;
      }
    },
    loadTarget(state, target_id) {
      onboarding.mutations.clean(state);
      state.loading = true;
      state.targetWasLoaded = false;
      state.orderId = target_id;
      targetsService.getTarget(target_id).then((response) => {
        if (response) {
          state.version = response.version;
          state.client_creation_date = response.client_creation_date;
          state.language_id = response.language_id;
          state.step3.tag_id = response.tag_id;
          state.bookers = response.bookers;
          state.should_call_target = response.should_call_target;
          state.contact_source = response.salesridge != null ? 1 : 0;
          state.order_type =
            response.order_type === "activation" ? "activation" : "acquisition";
          state.linkedContactsCount = Math.max(
            0,
            Number(response.linked_contacts_count) || 0
          );
          if (state.order_type === "activation") {
            state.activationContactsCount = state.linkedContactsCount;
          }
          state.companyName = response.company_name;
          state.validationTarget.status = response.validation
            ? response.validation.status
            : 0;
          state.validationTarget.comment = response.validation
            ? response.validation.comment
            : "";
          if (state.validationTarget.status != 0) {
            if (state.validationTarget.status == 1) {
              state.validationTarget.label = i18n.t("lang.label.verified");
            } else {
              state.validationTarget.label = i18n.t("lang.label.nonverified");
            }
          } else {
            state.validationTarget.label = i18n.t("lang.label.unverified");
          }

          let lang = "es";

          switch (response.language_id) {
            case 1:
              lang = "fr";
              break;
            case 2:
              lang = "en";
              break;
            case 3:
              lang = "es";
              break;
            case 4:
              lang = "it";
              break;
            case 5:
              lang = "it";
              break;
            default:
              lang = "fr";
              break;
          }
          state.adminPrice = response.admin_price;
          state.appt_price = response.appt_price;

          state.previewTemplate = response.preview_template;
          state.website =
            response.landing_page != null ? response.landing_page : "";
          state.closed = response.closed;
          state.descriptionSell =
            response.description_sell != null ? response.description_sell : "";
          state.descriptionOrder =
            response.description_order != null
              ? response.description_order
              : "";
          state.coldcallspec =
            response.coldcallspec != null ? response.coldcallspec : "";
          state.manual_cold_call_script =
            response.manual_cold_call_script != null
              ? response.manual_cold_call_script
              : "";
          state.step3.appointmentVolume = response.appt_quantity;
          state.step3.newEmailsPerDay =
            response.new_emails_per_day != null
              ? response.new_emails_per_day
              : 35;
          state.step3.totalEmailsPerDay =
            response.total_emails_per_day != null
              ? response.total_emails_per_day
              : 120;
          state.client_id = response.client_id;
          state.warmup_active =
            response.warmup_active == null ? 0 : response.warmup_active;
          state.create_mailboxes =
            response.create_mailboxes == null ? 1 : response.create_mailboxes;
          state.audience = response.audience;
          state.audience_description = response.audience_description;
          state.step3.duplicate_reason = response.duplicate_reason
            ? response.duplicate_reason
            : "New Campaign";
          const createdDate = moment(response.created);
          const launchDate = moment(response.launch_date_campaign);
          if (launchDate.isAfter(createdDate)) {
            state.step3.launchDate = response.launch_date_campaign;
          } else {
            state.step3.launchDate = response.created;
          }
          state.lang = lang;
          state.sequence_type = response.sequence_type;

          state.total_contacts = response.total_contacts
            ? response.total_contacts
            : 0;
          state.language_id = response.language_id;
          state.orderName = response.name;
          state.productName =
            response.product_name != null ? response.product_name : "";
          state.target_status_id = response.target_status_id;
          state.isMonthlyPaused = response.isMonthlyPaused;
          state.hoursPaused =
            response.hoursPaused != null ? response.hoursPaused : 0;
          state.total_meetings_this_month = response.total_meetings_this_month;
          state.step3.pausedDie = new Date(
            response.paused
          ).toLocaleDateString();
          state.user_id = response.user_id;
          state.descriptions.forEach((r) => {
            state.step1[r.arg] = response[r.arg];
          });
          if (response.data !== undefined) {
            state.target.positions = response.data.categories_level;
            state.target.departments = response.data.categories_function;
            state.target.contact_country = response.data.countries;
            state.target.company_location = response.data.region;
            state.target.categories_select =
              response.data.categories_select != undefined
                ? response.data.categories_select
                : [];
            state.target.category_select = response.data.category_select
              ? response.data.category_select
              : "Custom_Job_Titles"; // CUSTOM JOB TITLES es donde te habilita el AnyOf y notAnyOF para las ordenes viejas
            state.target.categories_jobs = normalizeKeywordFilter(
              response.data.categories_jobs
            );
            state.target.industry_keywords = normalizeKeywordFilter(
              response.data.industry_keywords
            );
            state.target.specialties = normalizeKeywordFilter(
              response.data.specialties
            );
            state.target.location_keywords = normalizeKeywordFilter(
              response.data.location_keywords
            );

            if (_.has(response.data.employees, "keywords")) {
              state.target.sizes = [];
              state.size = { keywords: {} };
              state.size.keywords.greater =
                response.data.employees.keywords.greater;
              state.size.keywords.less = response.data.employees.keywords.less;
              state.select_list_sizes.forEach((item) => {
                let label = item.label.replace("+", "").split("-");
                let less = label[0];
                let greater = label[1];
                if (
                  less <= state.size.keywords.less &&
                  greater >= state.size.keywords.greater
                ) {
                  state.target.sizes.push(item.id);
                }
                if (
                  greater == undefined &&
                  state.size.keywords.less == "10000000"
                ) {
                  state.target.sizes.push(item.id);
                }
              });
            } else {
              if (_.has(response.data, "employees")) {
                if (response.data.employees.greater == undefined) {
                  state.target.sizes = response.data.employees;
                  let greater = 0;
                  let less = 0;
                  state.target.sizes.sort();
                  onboarding.mutations.calculateSize(state);
                }
              }
            }

            let arrayDataIndustry = [];
            if (Array.isArray(response.data.categories_industry)) {
              if (Array.isArray(response.data.categories_industry)) {
                arrayDataIndustry = response.data.categories_industry.filter(
                  (item) => item != null
                );
              }
            }
            state.target.sectors_include = arrayDataIndustry;

            let arrayDataNotIndustry = [];
            if (Array.isArray(response.data.categories_industry)) {
              if (Array.isArray(response.data.categories_not_industry)) {
                arrayDataNotIndustry =
                  response.data.categories_not_industry.filter(
                    (item) => item != null
                  );
              }
            }
            state.target.summary = response.data.summary;
            state.target.places = response.data.places;
            state.target.summary = response.data.summary;
            state.target.sectors_exclude = arrayDataNotIndustry;

            state.step3.appointmentPrice = response.appt_price;

            if (
              response.questions &&
              response.questions.data &&
              Array.isArray(response.questions.data)
            ) {
              state.questions = response.questions;
            } else {
              state.questions = {
                data: [
                  {
                    question: 5,
                    description:
                      "Complete this step by putting yourself in the shoes of your prospects. What are the problems they encounter in the field on a daily basis? Give concrete examples",
                    answers: [
                      { number: 1, text: "" },
                      { number: 2, text: "" },
                      { number: 3, text: "" },
                    ],
                  },
                  {
                    question: 6,
                    description: "",
                    answers: [
                      { number: 1, text: "" },
                      { number: 2, text: "" },
                      { number: 3, text: "" },
                    ],
                  },
                ],
              };
            }

            state.offer_benefits = response.offer_benefits
              ? response.offer_benefits
              : ""; //Text Area
            state.offer_attractive = response.offer_attractive
              ? response.offer_attractive
              : ""; //TexArea
            state.offer_prospect = response.offer_prospect
              ? response.offer_prospect
              : 0; //Diferentes propuestas Select

            if (response.salesRep) {
              state.step3.teamMembers = [];
              response.salesRep.forEach((item) => {
                let member = item;
                state.step3.teamMembers.push(member);
              });
            }

            onboarding.mutations.setEmailDataToken(state);

            onboarding.mutations.setOrderData(state);

            if (state.updateStatusToPreapring) {
              let data = state.orderdata;
              data.change_target_status_to_active = true;
              data.from_credit_card_ok = true;
              targetsService
                .addTarget(data)
                .then((res) => {
                  // console.log(res);
                })
                .catch((err) => console.log(err));

              state.updateStatusToPreapring = false;
            }

            onboarding.mutations.validateForm(state);

            switch (state.language_id) {
              case 1:
                state.lang = "fr";
                break;
              case 2:
                state.lang = "en";
                break;
              case 3:
                state.lang = "es";
                break;
              case 4:
                state.lang = "it";
                break;
              case 5:
                state.lang = "pt";
                break;
              default:
                state.lang = "fr";
                break;
            }
          }

          if (state.typeForm !== "add") {
          }

          onboarding.mutations.loadCampaignStepTarget(state);
          state.loading = false;
          state.targetWasLoaded = true;
        } else {
          state.loading = false;
          state.targetWasLoaded = false;
        }
      }).catch(() => {
        state.loading = false;
        state.targetWasLoaded = false;
      });
    },
    loadCampaignStepTarget(state) {
      state.modelCampaingStep.campaign_steps = [];
      let subjectFilter = {
        currentPage: 1,
        cantPerPage: 1,
        step: 1,
        campaign_step_template_type_id: 1,
        campaign_step_template_part_id: 2,
        isPreviewEmail: false,
        withTags: true,
        tag_id: state.step3.tag_id,
        language_id: state.language_id,
      };

      targetsService
        .loadCampaingStepTarget({ target_id: state.orderId })
        .then(async (res) => {
          const hasSequenceCustom = res && res.length > 0 ? true : false;

          const targetIdAfterOpenAI =
            process.env.VUE_APP_ENV == "production" ? 2281 : 1179;

          // console.log('targetIdAfterOpenAI', targetIdAfterOpenAI)

          const targetCreatedAfterOpenAI =
            state.orderId > targetIdAfterOpenAI ? true : false;
          const currentSequenceTypeOfTarget = state.sequence_type;

          // Si sequence_type No ES NULL
          if (currentSequenceTypeOfTarget) {
            //Si es una orden nueva (post secuencia openAI) // 2281
            if (targetCreatedAfterOpenAI) state.tabs[2].disabled = true;
            state.modelCampaingStep.tabSelected.id =
              currentSequenceTypeOfTarget;
          } else {
            // Si sequence_type ES NULL

            //Si es una orden antes secuencia openAI)
            if (!targetCreatedAfterOpenAI) {
              //Si tengo respuesta con secuencia personalizada
              if (res.length > 0 && res) {
                state.modelCampaingStep.campaign_steps = res;
                state.modelCampaingStep.tabSelected.id = 1;
                state.sequence_type = 1;
              } else {
                // No tiene secuencia personalizada
                state.modelCampaingStep.tabSelected.id = 2;
                state.sequence_type = 1;
                state.loading = false;
              }
            } else {
              // es un target nuevo

              if (hasSequenceCustom) {
                state.modelCampaingStep.tabSelected.id = 1;
                state.sequence_type = 1;
              } else {
                state.modelCampaingStep.tabSelected.id = 3;
                state.sequence_type = 3;
                state.tabs[2].disabled = true;
              }
            }
          }

          if (hasSequenceCustom) {
            // ESTO ES CUANDO LA ORDEN TIENE SECUENCIA PERSONALIZADA .......
            state.modelCampaingStep.campaign_steps = res;
            //state.modelCampaingStep.tabSelected.id = 1
            // if (state.target_status_id != 3) {
            //   state.modelCampaingStep.tabSelected.disabled = true
            //   state.tabs[2].disabled = true
            //   state.tabs[3].disabled = true
            // }
            state.loading = false;
          } else {
            //state.modelCampaingStep.tabSelected.id = 2
            if (state.target_status_id != 3) {
              state.modelCampaingStep.tabSelected.disabled = true;
              //state.tabs[1].disabled = true
            }
            let subject = "";
            const response = await adminService
              .getCampaignStepTemplates(subjectFilter)
              .then((resItem) => {
                subject =
                  resItem.list.length > 0 ? resItem.list[0].message : "";
              });
            for (let index = 1; index < 7; index++) {
              let searchFilter = {
                currentPage: 1,
                cantPerPage: 1,
                step: index,
                campaign_step_template_type_id: 1,
                campaign_step_template_part_id: 1,
                isPreviewEmail: false,
                withTags: true,
                tag_id: state.step3.tag_id,
                language_id: state.language_id,
              };
              const resp = await adminService
                .getCampaignStepTemplates(searchFilter)
                .then((res) => {
                  state.modelCampaingStep.campaign_steps.push({
                    target_id: state.orderId,
                    step: index,
                    delay: index == 4 ? 30 : index > 1 ? 3 : 0,
                    time_to_send: "8",
                    subject: subject,
                    message: res.list[0].message,
                    recall_step: index == 4 ? 1 : 0,
                  });
                });
            }
            state.loading = false;
          }
        });
    },
    setCampaingSteps(state, data) {
      state.modelCampaingStep.campaign_steps = data;
    },

    setDisabledTab(state, id) {
      state.tabs[id].disabled = true;
    },

    setWarmupActive(state, status) {
      state.warmup_active = status;
    },

    setCreateMailboxes(state, status) {
      state.create_mailboxes = status;
    },

    calculateSize(state) {
      let greater = 0;
      let less = 0;
      state.target.sizes.forEach((value, index) => {
        let keywords = state.select_list_sizes[value].label
          .replace("+", "")
          .split("-");
        if (!keywords[1]) {
          keywords[1] = "10000000";
        }
        if (Number(keywords[0]) < greater || greater === 0) {
          greater = Number(keywords[0]);
        }
        if (Number(keywords[1]) > less) {
          less = Number(keywords[1]);
        }
      });

      if (state.size.keywords == undefined) {
        state.size = { keywords: {} };
      }

      state.size.keywords.greater = greater;
      state.size.keywords.less = less;
    },
    calculatePrice(state) {
      if (state.target_status_id == 3 && state.adminPrice != 1) {
        adminService.getAppointmentPrices().then((res) => {
          if (
            res.status === 200 &&
            res.result.appt_prices != undefined &&
            res.result.appt_prices.price_500 != undefined
          ) {
            let prices = res.result.appt_prices;

            let greaterThan = state.size.keywords.greater;
            let price = prices.price_lower_51;
            if (greaterThan >= 51 && greaterThan < 501) {
              price = prices.price_500;
            } else if (greaterThan >= 501 && greaterThan < 2001) {
              price = prices.price_2000;
            } else if (greaterThan >= 2001) {
              price = price_greater_2000;
            }
            state.step3.appointmentPrice = price;
          }
        });
      }
    },
    setTotalContact(state, data) {
      state.apollo.total_result = data;
    },
    getApollo(state, data) {
      state.isDisable = true;

      onboarding.mutations.setOrderData(state);
      let filters = state.orderdata.data;
      onboarding.mutations.calculateSize(state);
      if (state.size.keywords.less == 0 && state.size.keywords.greater == 0) {
        filters.employees = {};
      } else {
        if (state.size.keywords.less == 0 && state.size.keywords.greater > 0) {
          state.size.keywords = {
            greater: state.size.keywords.greater,
          };
        }
        filters.employees = state.size;
      }

      let categories_jobs;
      categories_jobs = filters.categories_jobs;
      categories_jobs = {
        anyof:
          categories_jobs.anyof !== undefined
            ? categories_jobs.anyof
            : undefined,
        notanyof:
          categories_jobs.notanyof !== undefined
            ? categories_jobs.notanyof
            : undefined,
        known:
          categories_jobs.known !== undefined
            ? categories_jobs.known
            : undefined,
        unknown:
          categories_jobs.unknown !== undefined
            ? categories_jobs.unknown
            : undefined,
        exactmatch:
          categories_jobs.exactmatch !== undefined
            ? categories_jobs.exactmatch
            : undefined,
      };
      filters.categories_jobs = categories_jobs;

      let industry_keywords;
      industry_keywords = filters.industry_keywords;
      industry_keywords = {
        anyof:
          industry_keywords.anyof !== undefined
            ? industry_keywords.anyof
            : undefined,
        notanyof:
          industry_keywords.notanyof !== undefined
            ? industry_keywords.notanyof
            : undefined,
      };

      let specialties;
      specialties = filters.specialties;
      specialties = {
        anyof: specialties.anyof !== undefined ? specialties.anyof : undefined,
        notanyof:
          specialties.notanyof !== undefined ? specialties.notanyof : undefined,
      };

      let location_keywords;
      location_keywords = filters.location_keywords;
      location_keywords = {
        anyof:
          location_keywords.anyof !== undefined
            ? location_keywords.anyof
            : undefined,
        notanyof:
          location_keywords.notanyof !== undefined
            ? location_keywords.notanyof
            : undefined,
      };

      filters.places = state.target.places;
      filters.industry_keywords = industry_keywords;
      filters.location_keywords = location_keywords;
      filters.target_id = state.orderId;
      filters.version = state.version;

      state.apollo.search_error = null;
      state.apollo.applied_filters = [];
      state.apollo.salesridge_payload = null;
      state.apollo.salesridge_launch_ui = null;

      targetsService.getApollo(filters).then((response) => {
        const searchError = parseContactSearchError(response);
        if (searchError) {
          state.apollo.search_error = searchError;
          state.apollo.total_result = 0;
          state.apollo.people = [];
          state.apollo.applied_filters = [];
          state.apollo.salesridge_payload = null;
          state.apollo.salesridge_launch_ui = null;
        } else if (response != "Invalid access credentials.") {
          state.apollo.total_result = response.pagination.total_entries;
          state.apollo.applied_filters = Array.isArray(response.applied_filters)
            ? response.applied_filters
            : [];
          state.apollo.salesridge_payload = response.salesridgePayload || null;
          state.apollo.salesridge_launch_ui = response.salesridge_launch_ui || null;
          let people = response.people.concat(response.contacts);

          if (!response.salesridge) {
            state.apollo.people = people.map((el) => {
              let city_country = "";

              if (el.city != undefined && el.city != null) {
                city_country += el.city;
              }
              if (el.photo_url == null || el.photo_url == undefined) {
                el.photo_url = require("@/assets/images/user.png");
              }

              if (el.country != undefined && city_country != "") {
                city_country += ", " + el.country;
              } else {
                city_country += el.country;
              }

              //console.log('city_country--------', city_country);

              return {
                ...el,
                city_country: city_country != null ? city_country : "",
                website:
                  el.organization && el.organization.website_url
                    ? el.organization.website_url
                    : "",
              };
            });
          } else {
            state.apollo.people = people.map((el) => {
              let city_country = "";

              if (el.location.city != undefined && el.location.city != null) {
                city_country += el.location.city;
              }
              el.photo_url = require("@/assets/images/user.png");

              if (el.location.country != undefined && city_country != "") {
                city_country += ", " + el.location.country;
              } else {
                city_country += el.location.country;
              }
              let organization = [];
              if (
                el &&
                el.employment &&
                el.employment.current &&
                el.employment.current.company
              ) {
                organization["description"] = "";
                organization["name"] = el.employment.current.company.name;
                organization["industry"] =
                  el.employment.current.company.industry.main_industry;
                if (el.employment.current.company.description) {
                  organization["description"] =
                    el.employment.current.company.description;
                }
                if (el.employment.current.company.specialties) {
                  organization["specialties"] =
                    el.employment.current.company.specialties.join(",");
                }
                if (el.employment.current.company.location_keywords) {
                  organization["location_keywords"] =
                    el.employment.current.company.location_keywords.join(",");
                }
              } else {
                organization["name"] = "";
              }
              //console.log('city_country--------', city_country);
              let title = "";
              if (
                el.employment &&
                el.employment.current &&
                el.employment.current.title
              ) {
                title = el.employment.current.title;
              }

              let linkedinurl = "";
              if (
                el.social_profiles &&
                el.social_profiles.linkedin &&
                el.social_profiles.linkedin.url
              ) {
                linkedinurl = el.social_profiles.linkedin.url;
              } else if (
                el.social_profiles &&
                el.social_profiles.professional_network &&
                el.social_profiles.professional_network.url
              ) {
                linkedinurl = el.social_profiles.professional_network.url;
              } else if (el.linkedin_url) {
                linkedinurl = Array.isArray(el.linkedin_url)
                  ? el.linkedin_url[0] || ""
                  : el.linkedin_url;
              }
              if (typeof linkedinurl === "string") {
                linkedinurl = linkedinurl.trim();
                if (
                  linkedinurl &&
                  !/^https?:\/\//i.test(linkedinurl) &&
                  !linkedinurl.startsWith("//")
                ) {
                  linkedinurl = "https://" + linkedinurl.replace(/^\/+/, "");
                } else if (linkedinurl.startsWith("//")) {
                  linkedinurl = "https:" + linkedinurl;
                }
              } else {
                linkedinurl = "";
              }
              return {
                ...el,
                name: el.full_name,
                title: title,
                linkedin_url: linkedinurl,
                organization: organization,
                city_country: city_country != null ? city_country : "",
                website: el.website ? "https://www." + el.website : "",
              };
            });
          }
          console.log("APOLLO RESULT MAP", state.apollo.people);
        } else {
          state.apollo.search_error = {
            key: "contact_search_error_invalid_credentials",
          };
          state.apollo.total_result = 0;
          state.apollo.people = [];
          state.apollo.applied_filters = [];
          state.apollo.salesridge_payload = null;
          state.apollo.salesridge_launch_ui = null;
        }

        onboarding.mutations.calculatePrice(state);
        onboarding.mutations.validateForm(state);
        state.isDisable = false;

        onboarding.mutations.validateStep(state);
      }).catch(() => {
        state.apollo.search_error = { key: "contact_search_error_generic" };
        state.apollo.total_result = 0;
        state.apollo.people = [];
        state.apollo.applied_filters = [];
        state.apollo.salesridge_payload = null;
        state.apollo.salesridge_launch_ui = null;
        state.isDisable = false;
        onboarding.mutations.calculatePrice(state);
        onboarding.mutations.validateForm(state);
        onboarding.mutations.validateStep(state);
      });
    },
    save(state) {
      state.loading = true;

      let statesize;
      if (state.size.keywords == undefined) {
        statesize = {};
      } else {
        if (state.size.keywords.less == 0 && state.size.keywords.greater == 0) {
          statesize = {};
        } else {
          if (
            state.size.keywords.less == 0 &&
            state.size.keywords.greater > 0
          ) {
            statesize.keywords = {
              greater: statesize.keywords.greater,
            };
          } else {
            statesize = state.size;
          }
        }
      }
      state.orderdata.client_id =
        authentication.state.user.role_id === "1" ||
        authentication.state.user.role_id === "5"
          ? state.client_id
          : authentication.state.user.client_id;

      state.orderdata.data.employees = statesize;

      targetsService.addTarget(state.orderdata).then((res) => {
        if (res != null && res != undefined && res > 0 && res) {
          state.orderId = res;
          state.client_id = state.orderdata.client_id;
          state.user_id = state.orderdata.user_id;
        }
        state.loading = false;
      });
    },
    copy(state, appointmentPrice) {
      state.isCopyTarget = state.orderId;
      state.orderId = 0;
      state.target_status_id = 3;
      state.orderName = state.orderName + " (Copy) ";
      state.salesRep = Array;
      state.step3.updateSales = Array;
      state.step3.teamMembers = Array;
      if (appointmentPrice != undefined) {
        state.appt_price = appointmentPrice;
      }
      router.push("/orders/add");
    },
    goToSettingAccount(state, data) {
      state.toSettingAccount = data;
    },
  },
  actions: {
    calculateSize(context) {
      context.commit("calculateSize");
    },
    setTypeForm(context, data) {
      context.commit("setTypeForm", data);
    },
    validateForm(context, data) {
      context.commit("validateForm", data);
    },
    validateStep(context, data) {
      context.commit("validateStep", data);
    },
    setOrderData(context, data) {
      context.commit("setOrderData", data);
    },
    setTotalContact(context, data) {
      context.commit("setTotalContact", data);
    },
    setCampaingSteps(context, data) {
      context.commit("setCampaingSteps", data);
    },
    setDisabledTab(context, id) {
      context.commit("setDisabledTab", id);
    },
    clean(context) {
      context.commit("clean");
    },
    save(context, data) {
      context.commit("setOrderData", data);
      context.commit("save");
    },
    setEmailDataToken(context, data) {
      context.commit("setEmailDataToken");
    },
    setAudience(context, data) {
      context.commit("setAudience", data);
    },
    setAudienceDescription(context, data) {
      context.commit("setAudienceDescription", data);
    },
    setOrderType(context, orderType) {
      context.commit("setOrderType", orderType);
    },
    setActivationContactsCount(context, count) {
      context.commit("setActivationContactsCount", count);
    },
    setActivationContactsStats(context, stats) {
      context.commit("setActivationContactsStats", stats);
    },
    setLinkedContactsCount(context, count) {
      context.commit("setLinkedContactsCount", count);
    },
    disableButton(context) {
      context.commit("disableButton");
    },
    changeLangAction(context, lang) {
      context.commit("changeLang", lang);
    },
    updateOrderName(context, orderName) {
      context.commit("updateOrderName", orderName);
      context.commit("disableButton");
    },
    updateDescriptionSell(context, descriptionSell) {
      context.commit("updateDescriptionSell", descriptionSell);
      context.commit("disableButton");
    },
    updateDescriptionOrder(context, descriptionOrder) {
      context.commit("updateDescriptionOrder", descriptionOrder);
      //context.commit('disableButton')
    },
    updateColdCallspec(context, coldcallspec) {
      context.commit("updateColdCallspec", coldcallspec);
      //context.commit('disableButton')
    },
    updateManualColdCallScript(context, manual_cold_call_script) {
      context.commit("updateManualColdCallScript", manual_cold_call_script);
      //context.commit('disableButton')
    },
    updateQuestions(context, data) {
      context.commit("updateQuestions", data);
      context.commit("disableButton");
    },
    updateWebsite(context, website) {
      context.commit("updateWebsite", website);
      context.commit("disableButton");
    },
    updateTargetStatusId(context, targetStatusId) {
      context.commit("updateTargetStatusId", targetStatusId);
    },
    updateStatusToPreapring(context, value) {
      context.commit("updateStatusToPreapring", value);
    },
    setOrderId(context, id) {
      context.commit("setOrderId", id);
    },
    setTab(context, id) {
      context.commit("setTab", id);
    },
    setIsCopyTarget(context, value) {
      context.commit("setIsCopyTarget", value);
    },
    setStatusOnboarding(context, item) {
      context.commit("setStatusOnboarding", item);
    },
    setWarmupActive(context, status) {
      context.commit("setWarmupActive", status);
    },
    setCreateMailboxes(context, status) {
      context.commit("setCreateMailboxes", status);
    },
    setTabStep3(context, id) {
      context.commit("setTabStep3", id);
    },
    setLanguageId(context, id) {
      context.commit("setLanguageId", id);
    },
    setClientId(context, id) {
      context.commit("setClientId", id);
    },
    setUserId(context, id) {
      context.commit("setUserId", id);
    },
    updateProductName(context, productName) {
      context.commit("updateProductName", productName);
      context.commit("disableButton");
    },
    updateCategorySelect(context, productName) {
      context.commit("updateCategorySelect", productName);
      context.commit("disableButton");
    },
    updateLink(context, link) {
      context.commit("updateLink", link);
      context.commit("disableButton");
    },
    updateTagId(context, tagId) {
      context.commit("updateTagId", tagId);
      context.commit("disableButton");
    },
    updateDescription(context, args) {
      context.commit("updateDescription", args);
    },
    updateServiceDescription(context, args) {
      context.commit("updateServiceDescription", args);
      context.commit("disableButton");
    },
    updateOfferProspect(context, offer) {
      context.commit("updateOfferProspect", offer);
      context.commit("disableButton");
    },
    skip(context, data) {
      context.commit("next");
      context.commit("disableSkip");
      context.commit("disableButton");
    },
    next(context, data) {
      context.commit("next", data);
      context.commit("disableButton");
      context.commit("disableSkip");
      context.commit("setOrderData", data);
      context.commit("save");
    },
    back(context) {
      context.commit("back");
      context.commit("disableButton");
      context.commit("disableSkip");
    },
    goTo(context, steps) {
      context.commit("goTo", steps);
    },
    goToStep(context, step) {
      context.commit("goToStep", step);
    },
    goToSubStep(context, substep) {
      context.commit("goToSubStep", substep);
    },
    updateConditionPayment(context, condition) {
      context.commit("updateConditionPayment", condition);
    },
    updateAppointmentVolume(context, appointmentVolume) {
      context.commit("updateAppointmentVolume", appointmentVolume);
    },

    updateCompanyName(context, company) {
      context.commit("updateCompanyName", company);
    },

    updateSales(context, sales) {
      context.commit("updateSales", sales);
    },

    updateLaunchDate(context, launchDate) {
      context.commit("updateLaunchDate", launchDate);
    },
    apolloData(context, apollo) {
      context.commit("apolloData", apollo);
    },
    deleteTeamMember(context, indexMember) {
      let array = onboarding.state.step3.teamMembers;
      array.splice(indexMember, 1);
      context.commit("updateTeamMembers", array);
    },
    addTeamMember(context, target) {
      onboarding.state.step3.teamMembers.push(target);
      //context.commit('updateTeamMembers', array);
    },
    clearTeamMember(context) {
      onboarding.state.step3.teamMembers = [];
    },
    updatePositions(context, positions) {
      context.commit("updatePositions", positions);
    },
    updateDepartments(context, departments) {
      context.commit("updateDepartments", departments);
    },
    updateSizes(context, sizes) {
      context.commit("updateSizes", sizes);
    },
    updateSectorsExclude(context, sectors_exclude) {
      context.commit("updateSectorsExclude", sectors_exclude);
    },
    updateSectorsInclude(context, sectors_include) {
      context.commit("updateSectorsInclude", sectors_include);
    },
    updateCategoryJobs(context, categories_jobs) {
      context.commit("updateCategoryJobs", categories_jobs);
    },
    updateIndustryKeywords(context, industry_keywords) {
      context.commit("updateIndustryKeywords", industry_keywords);
    },
    updateSpecialtiesKeywords(context, specialties) {
      context.commit("updateSpecialtiesKeywords", specialties);
    },
    updateLocationKeywords(context, location_keywords) {
      context.commit("updateLocationKeywords", location_keywords);
    },
    updateCountry(context, countries) {
      context.commit("updateCountries", countries);
    },
    updateRegion(context, regions) {
      context.commit("updateRegions", regions);
    },
    updateSummary(context, data) {
      context.commit("updateSummary", data);
    },
    updateBenefitsOffer(context, data) {
      context.commit("updateBenefitsOffer", data);
      context.commit("disableButton");
    },
    updateOfferAttractive(context, data) {
      context.commit("updateOfferAttractive", data);
    },
    loadTarget(context, data) {
      context.commit("loadTarget", data);
    },
    getApollo(context, data) {
      context.commit("getApollo", data);
    },
    updatePrice(context, data) {
      context.commit("updatePrice", data);
    },
    updateAdminPrice(context, data) {
      context.commit("updateAdminPrice", data);
    },
    updateNewEmailsPerDay(context, data) {
      context.commit("updateNewEmailsPerDay", data);
    },
    updateTotalEmailsPerDay(context, data) {
      context.commit("updateTotalEmailsPerDay", data);
    },
    updatePreviewTemplate(context, data) {
      context.commit("updatePreviewTemplate", data);
    },
    copy(context, data) {
      context.commit("copy", data);
    },
    goToSettingAccount(context, data) {
      context.commit("goToSettingAccount", data);
    },
    updateStartProcess(context) {
      context.commit("setStartProcess");
    },
    updateDuplicateReason(context, data) {
      context.commit("setDuplicateReason", data);
    },
    setLoading(context, status) {
      context.commit("setLoading", status);
    },
    setIsMonthlyPaused(context, status) {
      context.commit("setIsMonthlyPaused", status);
    },
    setHoursPaused(context, status) {
      context.commit("setHoursPaused", status);
    },
  },
  getters: {
    getLang(state) {
      return state.lang;
    },
    getStartProcess(state) {
      return state.startProcess;
    },
    getStatusOnboarding(state) {
      return state.statusOnboarding;
    },
  },
};
